import { RootState } from '@reducers';

export const selectFeatureActionRequest = (state: RootState) => state.featureReducer.actionRequestReducer;
